export const STATUS_DESPESA_RECORRENTE = {
    PENDENTE: { label: "Pendente", emoji: "🟡", badge: "bg-amber-100 text-amber-800", dot: "bg-amber-400" },
    ENVIADO: { label: "Enviado", emoji: "🟢", badge: "bg-emerald-100 text-emerald-800", dot: "bg-emerald-500" },
    MARCADO_MANUALMENTE: { label: "Marcado manualmente", emoji: "🔵", badge: "bg-sky-100 text-sky-800", dot: "bg-sky-500" },
    ATRASADO: { label: "Atrasado", emoji: "🔴", badge: "bg-red-100 text-red-800", dot: "bg-red-500" },
    PAGO: { label: "Pago", emoji: "✅", badge: "bg-teal-100 text-teal-800", dot: "bg-teal-500" },
    CANCELADA: { label: "Cancelada", emoji: "⚪", badge: "bg-gray-100 text-gray-700", dot: "bg-gray-400" },
};

export function statusInfo(status) {
    return STATUS_DESPESA_RECORRENTE[status] || { label: status || "-", emoji: "", badge: "bg-muted text-foreground", dot: "bg-muted-foreground" };
}
